const { listChildren } = require('./list-children')
const { listPrograms } = require('../../../program/api')
const { createLocationExport } = require('../../tools/export-location-tools')
const { DEFAULT_LOCATION_ID_HIERARCHY } = require('../../tools/get-region-level-sub-tiers')

// This is used only by PSM.
// SL exports allocations, which include product info.
exports.exportLocations = async (state, { template, date, locationIdHierarchy = DEFAULT_LOCATION_ID_HIERARCHY } = {}) => {
  const locations = await listChildren(
    state, state.user.location.id, {date, includeInactive: true}
  )
  const programs = await listPrograms(state)
  return createLocationExport({
    locations,
    programs,
    template,
    locationIdHierarchy
  })
}
